/**
 * Takes an object (as this is stored in the DB) and transforms it to an array to be processed
 * by normalizr
 *
 * @param   {object}  logos
 *
 * @return  {array}
 */
export function transformLogos(logos) {
    return Object.entries(logos).map(([id, logo]) => ({ ...logo, id }));
}
